<!--<pane-back-button [buttonFacingRight]="false" text="close" backToLeftPane=""></pane-back-button>-->
<div class="chats-content">

    <div class="px-3">
        <input (keydown.enter)="enterPressed($event)"
               [(ngModel)]="searchText"
               (focus)="setSearchActive(true)"
               class="mt-4 w-100 input input-round search"
               placeholder="Search Chats" />
    </div>
    <div class="chats-holder mt-4">
        <div *ngFor="let chat of chats; trackBy: trackById">
            <chats-bar-chat-item [chat]="chat"></chats-bar-chat-item>
        </div>
    </div>
</div>
